<template>
  <div class="loc-prod-detail-add-stash-main">
    <div class="loc-prod-detail-add-stash-header">
      <h1 class="is-size-20px has-text-weight-semibold">{{ product.name }}</h1>
      <p class="company-name is-size-12px mt10 is-uppercase" v-if="product.brand && (product.brand.name != 'No Brand')">{{ product.brand.name }}</p>
    </div>
    <div class="loc-addto-stash-main mt20" ref="variantbox">
      <ul>
        <li v-for="(variant, index) in variants" v-bind:key="'variant_id_'+ variant.id" :class="(variant.is_active ? ' active-variant ' : '') + (index > 2 ? 'hide' : '')">
          <div class="variant-left">
              <div :class="'variant-size-box hover-opacity-7' + (variant.is_active ? ' active' : '') + (variant._in_stock ? '' : ' out-of-stock-mark')" @click="selectVariant(index, variant)">
                {{ variant.size }}
                <span class="variant-sale-tag" v-if="variant._in_stock && variantHasSalePrice(variant)">{{ variantSalePercentage(variant) }}</span>
              </div>
          </div>
          <div class="variant-right">
            <template v-if="variant._in_stock">
              <div class="default-price-weight">
                <div class="variant-default-display" v-if="isProductDriedFlowerOrPreRolls">
                  <p v-if="parseFloat(variant.weight_equivalent_dry_cannabis) > 0">{{ perGramPrice(variant) }}</p>
                </div>
                <div :class="'variant-qty-display' + ( (parseFloat(variant.weight_equivalent_dry_cannabis) > 0) && isProductDriedFlowerOrPreRolls ? '' : ' no-border' )">
                  <p class="price has-text-weight-semibold">${{ variantPrice(variant) }}</p>
                  <p class="unit-left has-text-danger"> {{ remainingThreshold(variant) }}</p>
                </div>
              </div>

              <div class="active-quantity-block">
                <div class="quantity-block is-width-xs mb0">
                  <button value="-" @click="decreaseQty()" class="button minus bg-secondary hover-opacity-7 text-white"><i class="fas fa-minus"></i></button>
                  <div class="field mb0">
                    <div class="control disable-click-event">
                      <span v-text="qty" class="display-qty min-width-100 has-text-weight-bold has-text-dark"></span>
                    </div>
                  </div>
                  <button  @click="increaseQty()" value="+" class="button plus bg-secondary hover-opacity-7 text-white">
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </template>

            <div class="out-of-stock justify-content-between is-flex align-items-center" v-else>
              <p class="has-text-danger text-center mr5">Out Of Stock</p>
           
              <button v-if="checkValue(outofStockSubscribeVariants, variant.id)" class="button text-white is-size-14 bg-secondary" @click.prevent="cancelNotificationWhenProductAvailable(variant)">CANCEL NOTIFY</button>
              <button v-else class="button is-size-14 bg-secondary text-white" @click.prevent="notifyVaraintOutOfStock(variant)">NOTIFY</button>

            </div>
            
          </div>
        </li>
      </ul>
      

      <div class="mt10 variant-display-handler" v-if="variants.length > 3">
        <p class="relative is-size-16px has-text-weight-semibold text-center pointer" @click="toggleVariants()">
          <span class="show-all-sizes text-secondary hover-opacity-8">Show All Sizes</span> 
          <span class="hide-all-sizes text-secondary hover-opacity-8">Hide</span> 
          <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.91 0.296875L6.5 4.87687L11.09 0.296875L12.5 1.70687L6.5 7.70687L0.5 1.70687L1.91 0.296875Z" fill="#008767"/>
          </svg>
        </p>
      </div>
    </div>
 
    <template v-if="product.discontinued == true || totalNumberOfAddableVariants == 0">
        <a
          class="button is-flex justify-content-between has-background-danger has-text-semibold-18">
          <span class="add-to-cart">Product currently not available !</span>
        </a>
    </template>

    <template v-else>
      <div class="total-box">
        <div class="is-flex justify-content-between mb-20">
          <span class="is-size-22px has-text-weight-semibold">Total</span>
          <div class="is-flex align-items-center">{{ totalGram }} <span class="is-size-22px has-text-weight-semibold ml10">${{ totalPrice }}</span></div>
        </div>
        <a
          @click.prevent="!selectedVariant.id ? '' : addToCart()"
          :disabled="!selectedVariant.id"
          class="button is-height-44 is-flex bg-secondary add-to-cart-btn has-text-weight-bold">
          <span v-if="!selectedVariant.id" class="has-text-weight-normal text-white">Please select the size.</span> <span class="text-white" v-else>ADD TO STASH</span>
        </a>
      </div>
    </template>
    
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
import Env from '@/env';
import CartApis from '@/Components/Controllers/CartApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import UserApis from '@/Components/Controllers/UserApis';

export default {
  name: 'LocationProductAddToStash',
  data() {
    return {
      variants: this.productvariants,
      selectedVariant: {},
      qty: 1,
    };
  },
  
  props:{
    product: {
      required: true,
      type: Object,
    },
    productvariants: {
      required: true,
      type: Array,
    },
    outofStockSubscribeVariants: {
      required: true,
      type: Array,
    },
  },

  computed: {
    totalNumberOfAddableVariants() {
      return Helpers.getTotalNumberOfAddableVariants(this.productvariants);
    },  
    isProductDriedFlowerOrPreRolls() {
      return (this.product.category && this.product.category.product_form && (this.product.category.product_form == 'dried flower' || this.product.category.product_form == 'pre rolled') ) ? true : false;
    },
     /**
     * Calculate total
     */
    totalPrice() {
      if(!_.isEmpty(this.selectedVariant)) {
        let price = this.variantPrice(this.selectedVariant); // sale or regular price 
        let total = price * this.qty;
        return (Math.round(total * 100) / 100).toFixed(2);
      }
      return (0).toFixed(2);
    },

    /**
     * Calculate total weight
     */
    totalGram() {
      if(!_.isEmpty(this.selectedVariant)) {
        // lets calculate per gm value
        // must be greater than zero else will be infinity
        let dryweight = parseFloat(this.selectedVariant.weight_equivalent_dry_cannabis);
        if(dryweight > 0) {
          let totalDryWeight = this.selectedVariant.weight_equivalent_dry_cannabis * this.qty;
          return (Math.round(totalDryWeight * 100) / 100).toFixed(2) +  this.product.weighing_unit + ' for ';
        } 
        return '';
      }
      return '';
    },

    thc() {
      return Helpers.getTHCValue(this.product);
    },

    cbd() {
      return Helpers.getCBDValue(this.product);
    },
    
    ...mapGetters({
      vg_selectedStore: "location/selected",
      vg_favProducts: "favouriteproducts/list",
      vg_userId: "getLoggedInUserId",
      vg_weightOnCart: "cart/cartWeight",
      vg_cannabisLimit: "location/cannabis_limit",
      vg_cartItems: "cart/cartItems",
      vg_cartId: 'cart/id',
    }),
  },

  async mounted() {
    // select if only 1 variant available
    if(this.productvariants && this.productvariants.length == 1) {
      let firstAvailableVariant = Helpers.getFirstAvailableVariant(this.productvariants);
      if(firstAvailableVariant != undefined) {
        this.selectVariant(0, firstAvailableVariant);
      }
      
    }
  },

  destroyed() {
    this.va_setOutOfStockPendingItem({});
  },
  
  methods: {

    /**
     * Add To cart
     */
    async addToCart() {
      // If we dont have cart id create cart first 
      if(this.vg_cartId == ''){
        await CartApis.createCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
      }
      // threshold 
      if(this.totalNumberOfAddableVariants < 1){
        this.va_spinner(false);
        return this.va_snackbar({
          type: 'warning', 
          message: 'Products variants are not available.',
        });
      }
  
       // Check if variant is selected 
      if( _.isEmpty(this.selectedVariant) ) {
        this.va_spinner(false);
        return this.va_snackbar({
          type: 'warning', 
          message: 'Please Select Size.',
        });
      }

      // If already exceed limit
      if( parseFloat(this.vg_weightOnCart) > parseFloat(this.vg_cannabisLimit) ){
        this.va_spinner(false);
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: this.vg_weightOnCart,
          modal: true,
        });
        return false;
      }

      // If going to exceed limit on adding this item, no qty now this.qty *
      let currentProductWeight =  parseFloat(this.selectedVariant.weight_equivalent_dry_cannabis * this.qty);
      let finalWeight = parseFloat(currentProductWeight) + parseFloat(this.vg_weightOnCart);

      if(finalWeight > parseFloat(this.vg_cannabisLimit) ) {
        this.va_spinner(false);
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: finalWeight,
          modal: true,
        });
        return false;
      }

      let checkExistingProduct = _.find(this.vg_cartItems, { location_product_id: parseInt(this.product.id), location_product_variant_id: parseInt(this.selectedVariant.id) });
      if(checkExistingProduct == undefined){
        // validate if we have instock
        if(parseInt(this.qty) > parseInt(this.selectedVariant.no_of_units - this.selectedVariant.inventory_threshold) ){
          // reject cannot add qty more than no of units
          this.va_spinner(false);
          return this.va_snackbar({
            message: Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        } 

        await this.addCartItem();
        this.va_spinner(false);

      } else {
        // Now before update lets check no of qty he can add
        let existingProductQty = checkExistingProduct.unit;
        // let maxCanBeAdded = parseInt(this.selectedVariant.no_of_units) - parseInt(existingProductQty);
        let maxCanBeAdded = parseInt(this.selectedVariant.no_of_units - this.selectedVariant.inventory_threshold) - parseInt(existingProductQty);

        if(parseInt(this.qty) > maxCanBeAdded){
          // reject cannot add qty more than no of units
          this.va_spinner(false);
          return this.va_snackbar({
            message: Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        } 
        await this.updateCartItem(checkExistingProduct);

      }
    },


     /**
     * Add cart item
     */
    async addCartItem() {
      let obj = {
        user_id: this.$store.getters.getLoggedInUserId,
        location_id: this.vg_selectedStore.id,
        cart_id: this.vg_cartId == '' ? 'Not available' : this.vg_cartId,
        location_product_id: this.product.id,
        category_id: this.product.category_id ? this.product.category_id : null,
        category_name: this.product.category ? this.product.category.name : null,
        thc_cbd_value_type: this.product.category ? this.product.category.thc_cbd_value_type : '',
        product_name: this.product.name,
        product_family: this.product.product_family,
        product_id: this.product.id,
        product_image: this.product.image ? this.product.image : 'http://unohop.dev.unoapp.io/img/leaf.47bfc5db.png',
        product_type: this.product.product_type ? this.product.product_type : '',
        brand_name: this.product.brand ? this.product.brand.name : '',
        location_product_variant_id: this.selectedVariant.id,
        location_variant_sku: this.selectedVariant.sku,
        location_product_variant_external_sku: this.selectedVariant.external_id,
        price: this.variantPrice(this.selectedVariant), // return sale slse regular one
        actual_price: this.selectedVariant.price,
        weight: this.selectedVariant.weight_equivalent_dry_cannabis ? this.selectedVariant.weight_equivalent_dry_cannabis : 0,
        unit: this.qty,
        app_version: Env.appVersion,
        platform: Env.appPlatform,
        //product: this.product, // triple to match fav style
        selected_variant: this.selectedVariant,        
        weighing_unit: this.product.weighing_unit ? this.product.weighing_unit : 'null',
      }

      // Add THC,CBD,cannabis attributes only if family is cannabis
      if(this.product.product_family == 'cannabis'){
        obj.cannabis_attributes = this.product.cannabis_attributes ? Helpers.unsetKeyFromObj(['createdAt', 'updatedAt', 'created_at', 'updated_at'], this.product.cannabis_attributes) : {};
        obj.thc_cbd_levels = this.product.thc_cbd_levels ? Helpers.unsetKeyFromObj(['created_by', 'createdAt', 'updated_by', 'updatedAt', 'created_at', 'updated_at'], this.product.thc_cbd_levels) : {};
      }

      let res = await CartApis.add(obj, this);
      if(res.status == 200) {
        // we get cart id here assign it
        this.va_setCartId(res.data.payload.id);
        this.va_setCartDetail(res.data.payload);
        if(this.$store.getters.getLoggedInUserId){
          // lets save the data on vbout
          VboutApis.addCartItem(obj, Helpers.getLocationProductFullUrl(this, obj.product_id), this.vg_selectedStore.id);
        }
        // G tracking add to cart
        this.$gtag.event('add_to_cart', { 
          items: [
            {
              id: this.product.id,
              name: this.product.name, 
              brand: this.product.brand ? this.product.brand.name : null,
              category: this.product.category ? this.product.category.name : null,
              variant: this.selectedVariant.size ? this.selectedVariant.size : null,
              quantity: parseInt(this.qty),
              price: parseFloat(this.selectedVariant.sale_price) > 0 && parseFloat(this.selectedVariant.sale_price) < parseFloat(this.selectedVariant.price) ? this.selectedVariant.sale_price : this.selectedVariant.price,
            }
          ]
        });
        // only for non login because for login pubnub emits
        if(!this.$store.getters.getLoggedInUserId){
          // If guest user else pubnub will throw
          this.va_snackbar({
            message: res.data.msg,
            type: 'success',
          });
        }
        return obj;
      } else {
        this.va_snackbar({
          message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
          type: res.status == 200 ? 'success' : 'error',
        });
        return false;
      }
    },

     /**
     * Update cart item
     */
    async updateCartItem(item) {
      this.va_spinner(true);
      //Clone the object and filter
      var obj = _.clone(item);
      obj.cart_item_id = item.id;
      obj.unit = parseInt(item.unit) + parseInt(this.qty);
      obj.app_version = Env.appVersion;
      obj.platform = Env.appPlatform;
      let res = await CartApis.update(obj);
      this.va_spinner(false);
      if(res.status == 200) {
        if(this.$store.getters.getLoggedInUserId == false){
          // If guest user 
          this.va_snackbar({
            message: res.data.msg,
            type: 'success',
          });
        } else {
         // For vbout only push current added because its add api not update api
          obj.unit = parseInt(this.qty);
          VboutApis.addCartItem(obj, Helpers.getLocationProductFullUrl(this, obj.product_id), this.vg_selectedStore.id);
        }
        return true;
      } 
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        type: res.response.status == 200 ? 'success' : 'error',
      });
      return false;
    },

    /**
     * Toggle variants list
     */
    toggleVariants() {
      this.$refs['variantbox'].classList.toggle('show-all')
    },

    /**
     * Calculate price per gm 
     */
    perGramPrice(variant) {
      if(!_.isEmpty(variant)) {
        // lets calculate per gm value
        // must be greater than zero else will be infinity
        let dryweight = parseFloat(variant.weight_equivalent_dry_cannabis);
        if(dryweight > 0) {
          let price = this.variantPrice(variant); // sale or regular price 
          let calculation = price/dryweight;
          return '$' + (Math.round(calculation * 100) / 100).toFixed(2) +  ' per ' + this.product.weighing_unit;
        } 
        return '';
      }
      return '';
    },
    
    /**
     * Decrease
     */
    decreaseQty() {
      if(this.qty > 1){
        this.qty--;
      }
    },

    /**
     * Increase quantity
     */
    increaseQty() {
      // before increase check if can increase within limit ot not
      if(parseFloat(this.vg_weightOnCart) > parseFloat(this.vg_cannabisLimit) ){
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: this.vg_weightOnCart,
          modal: true,
        });
      } else {
        let totalQtyAfterAdd = this.qty + 1;
        let maxQtyCanAdd = parseInt(this.selectedVariant.no_of_units - this.selectedVariant.inventory_threshold);
        if(totalQtyAfterAdd > maxQtyCanAdd){
          // reject cannot add qut more than no of units
          return this.va_snackbar({
            message:  Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        }  
        let newWeight = parseFloat(this.selectedVariant.weight) + parseFloat(this.vg_weightOnCart)
        if(newWeight > parseFloat(this.vg_cannabisLimit) ){
          bus.$emit('show-modal-cart-limit-exceed', {
            overWeight: newWeight.toFixed(2),
            modal: true,
          });
        } else {
          this.qty = totalQtyAfterAdd;
        }
      }
    },

   
    /**
     * Select variant
     */
    selectVariant(index, variant) {
      this.qty = 1; // reset qty
      this.selectedVariant = variant;
      this.variants.map( (item, innerIndex) => { 
        if(innerIndex == index){
          item.is_active = true; 
        } else {
          item.is_active = false; 
        }
      })
    },

    
    /**
     * Variant show sale price if on sale else regular price
     */
    variantPrice(item) {
      // parseFloat(item.sale_price) > 0 && 
      if(item.sale_price && (parseFloat(item.sale_price) < parseFloat(item.price)) ){
        return item.sale_price.toFixed(2);
      }
      return item.price.toFixed(2);
    },

    /**
     * Variant sale price
     */
    variantHasSalePrice(item) {
      // parseFloat(item.sale_price) > 0 && 
      if((parseFloat(item.sale_price) < parseFloat(item.price)) ){
        return true;
      }
      return false;
    },

     /**
     * Sale percentage
     */
    variantSalePercentage(item) {
      let salePercentData =  ((item.price-item.sale_price) / item.price)*100;
      return ((salePercentData - Math.floor(salePercentData)) ? salePercentData.toFixed(0) : salePercentData) + '% OFF';
    },

    /**
     * Variant remaining threshold
     */
    remainingThreshold(item) {
      // If the no of item and threshold substract is less than 5 show 
      let itemLeft = parseFloat(item.no_of_units) - parseInt(item.inventory_threshold);
      if( itemLeft < 6 ){
        return itemLeft + ' Unit' + (itemLeft == 1 ? '' : 's') + '  Left';
      }
      return '';
    },

    /**
     * Out of stock Notify
     */
    notifyVaraintOutOfStock(variant) {
      // Check if user is logged in , based on use status set modal
      if(this.vg_userId){
        bus.$emit('variant-out-of-stock-notification', {
          modal: true,
          variant: variant,
        })
      } else {
        this.va_setOutOfStockPendingItem(variant);
        bus.$emit('show-signup-login-option-modal', {
          modal: true,
          message: '',
        })
      }
    },

    /**
     * Check value in array
     */
    checkValue(arr, val) {
      let record = _.find(arr, function(o) { return o.variant_id ==  val });
      if(record != undefined) {
        return record;
      }
      return false;
    },

    /**
    * Cancel notification
    */
   async cancelNotificationWhenProductAvailable(variant) {
     this.va_spinner(true);
     let getCurrentNotificationId = _.find(this.outofStockSubscribeVariants, function(o) { return o.variant_id == variant.id });
      if(getCurrentNotificationId || getCurrentNotificationId != undefined) {
        let res = await UserApis.removeOutOfstockNotification(getCurrentNotificationId.id);
        this.va_spinner(false);
          if(res.status == 200){
            bus.$emit('refetch-outof-stock-notification', true);
          }
          this.va_snackbar({
            type: res.status == 200 ? 'success' : 'warning',
            message: res.status == 200 ? res.data.msg : res.response.data.msg,
          });
      }
   },


    ...mapActions({
      va_setCartId: "cart/setId",
      va_setCartDetail: "cart/setCartDetail",
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setSignupModal: "signupmodal/setModal",
      va_setOutOfStockPendingItem: "outofstocksubscriptions/setPendingItem",
    })

  },
};
</script>
